import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReCaptchaV3Service } from 'ngx-captcha';

@Component({
  selector: 'bra-recaptcha',
  templateUrl: './bra-recaptcha.component.html',
  styleUrls: ['./bra-recaptcha.component.css'],
})
export class BraRecaptchaComponent implements OnInit {
  @Input()
  siteKey: string = '';

  @Input()
  action: string = 'submit';

  @Output() tokenChange = new EventEmitter<string>();
  @Output() loaded = new EventEmitter<boolean>();

  constructor(private recaptchaV3Service: ReCaptchaV3Service) {}

  ngOnInit() {
    this.execute();
    this.loaded.emit(true);
  }

  execute(): void {
    if (!this.siteKey) {
      return;
    }

    this.recaptchaV3Service.execute(
      this.siteKey,
      this.action,
      (token: string) => {
        this.tokenChange.emit(token || '');
      },
    );
  }

  reload(): void {
    this.tokenChange.emit('');
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-recaptcha/bra-recaptcha.component.ts